import React from 'react';
import AshopClock from './AshopClock';

const ClockPreview = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 p-12">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Clock Preview</h1>
        <p className="text-gray-500 mb-10">Three size variations of the Ashop analog clock with store logo in the center.</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Compact */}
          <div className="bg-white rounded-2xl shadow-xl p-6 flex flex-col items-center">
            <h3 className="text-sm uppercase tracking-wider text-gray-400 font-semibold mb-4">Compact (120px)</h3>
            <AshopClock size={120} showDigital={true} />
            <p className="text-xs text-gray-400 mt-4 text-center">Top-right corner of admin header</p>
          </div>

          {/* Medium */}
          <div className="bg-white rounded-2xl shadow-xl p-6 flex flex-col items-center">
            <h3 className="text-sm uppercase tracking-wider text-gray-400 font-semibold mb-4">Medium (180px)</h3>
            <AshopClock size={180} showDigital={true} />
            <p className="text-xs text-gray-400 mt-4 text-center">Floating card on dashboard</p>
          </div>

          {/* Large */}
          <div className="bg-white rounded-2xl shadow-xl p-6 flex flex-col items-center">
            <h3 className="text-sm uppercase tracking-wider text-gray-400 font-semibold mb-4">Large (260px)</h3>
            <AshopClock size={260} showDigital={true} />
            <p className="text-xs text-gray-400 mt-4 text-center">Hero banner on dashboard</p>
          </div>
        </div>

        <div className="mt-10 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-2xl shadow-xl p-8 flex items-center justify-between">
          <div className="text-white">
            <h2 className="text-2xl font-bold">Ashop Admin</h2>
            <p className="text-indigo-200 text-sm mt-1">Header placement preview</p>
          </div>
          <AshopClock size={140} showDigital={false} />
        </div>
      </div>
    </div>
  );
};

export default ClockPreview;
